import { Action } from 'redux-actions';
import { SET_EVERY_TRAVEL_CART, SetEveryTravelCart } from './actions';

export interface EveryTravelState {
	cartId: number;
}

const initialState: EveryTravelState = {
	cartId: null
};

export const everyTravelReducer = (state: EveryTravelState = initialState, action: Action<SetEveryTravelCart>) => {
	if (action.type === SET_EVERY_TRAVEL_CART) {
		return {
			...state,
			cartId: action.payload.cartId
		};
	}

	return state;
};
